import styled from "@emotion/styled";
import { Button, TextField } from "@mui/material";

export const DashboardPageContainer = styled.main({
	display: "flex",
	flexDirection: "column",
	minHeight: "100vh"
});

export const DashboardContent = styled.div(({ theme }) => ({
	backgroundColor: "#ffffff",
	backgroundImage: "linear-gradient(to bottom, #006594 0%, #006594 25%, #ffffff 100%)",
	backgroundRepeat: "no-repeat",
	backgroundSize: "100% 30vh",
	boxSizing: "border-box",
	display: "flex",
	flex: "1 1 auto",
	flexDirection: "column",
	padding: "20px 24px 48px",
	[theme.breakpoints.down("md")]: {
		padding: "16px"
	}
}));

export const WelcomeHeading = styled.h1(({ theme }) => ({
	...theme.project.typography.heading.h5,
	color: theme.project.colors.fontColors.contrast,
	margin: "0 0 16px"
}));

export const DashboardSearchPanel = styled.section(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	boxSizing: "border-box",
	padding: "16px"
}));

export const DashboardSearchForm = styled.form(({ theme }) => ({
	alignItems: "flex-start",
	display: "grid",
	gap: "8px",
	gridTemplateColumns: "minmax(0, 1fr) max-content",
	[theme.breakpoints.down("md")]: {
		gridTemplateColumns: "1fr"
	}
}));

export const DashboardSearchTextField = styled(TextField)({
	width: "100%"
});

export const DashboardSearchButton = styled(Button)(({ theme }) => ({
	height: "40px",
	[theme.breakpoints.down("md")]: {
		width: "100%"
	}
}));

export const DashboardCardsSection = styled.section({
	marginTop: 16,
	width: "100%"
});

export const DashboardStaticAd = styled.div({
	boxSizing: "border-box",
	height: 313,
	overflow: "hidden",
	width: 330,
	"& > svg": {
		display: "block",
		height: "100%",
		width: "100%"
	}
});
